export class Period {
  public from?: any;
  public to?: any;

  constructor(from: any, to: any) {
    this.from = from;
    this.to = to;
  }
}
